<template>
  <div
    :key="sectionInfo.title + '_commonBand'"
    ref="contentsOverlay"
    class="live-home-list"
    :style="getColor"
  >
    <div class="live-home-hd">
      <h3 v-band-title class="live-home-title">
        {{ sectionInfo.title }}&nbsp;
      </h3>
      <div v-if="hasFilter" class="filter-area">
        <div class="filter-item-area">
          <div>
            <filter-list-for-device
              v-for="(filterItem, index) in filterObject.filterlist"
              :key="'filter_' + index"
              :filter-item="filterItem"
              :filter-title="filterTitleMap[index] || filterItem.title"
              :filter-index="index"
              @set-filter-query="setFilterQuery"
            />
          </div>
        </div>
      </div>
    </div>
    <infinite-scroll-cell-list-live-player
      v-if="hasCellList"
      key="infinite-scroll-cell-list-live-player"
      :cell-list="cellList"
      :thumbnail-info="thumbnailInfo"
      :container-class-name="getCellListContainerClassName"
      @load-more="loadMore"
    />
    <div v-if="showEmptyList" class="empty-cell-list">
      <div class="attention-mark-area">
        <empty-image />
      </div>
      <div class="text-area">채널이 없어요.</div>
    </div>
  </div>
</template>

<script>
  import { bandTitle } from '@/common/directives'
  import EventModelClass from '@/common/model/EventModelClass'
  import { parse, parseUrl } from 'query-string'
  import {
    getBandTypeInfoByCellType,
    getCellListContainerClassName,
  } from '@/common/image.util'
  import { get, merge } from 'lodash'
  import { FETCH_BAND_INFO } from '@/store/types/actions.type'
  import { mapActions } from 'vuex'
  import FilterListForDevice from '@/components/section/template/FilterListForDevice'
  import { EventService } from '@/common/api/api.service'
  import EmptyImage from '@/assets/svg/common/img_empty.svg'
  import InfiniteScrollCellListLivePlayer from '@/components/section/template/cell/InfiniteScrollCellListLivePlayer'

  export default {
    name: 'TemplateLiveChannelList',
    directives: { bandTitle },
    components: {
      InfiniteScrollCellListLivePlayer,
      FilterListForDevice,
      EmptyImage,
    },
    props: ['sectionInfo', 'bottomTab'],
    data() {
      return {
        showEmptyList: false,
        isLoading: false,
        hasFilter: false,
        hasCellList: false,
        cellList: [],
        getTime: '',
        thumbnailInfo: {},
        filterTitleMap: {},
        filterObject: {},
        endOfList: false,
        filterQueryMap: {},
        currentEvent: {},
        offset: 0,
        limit: 20,
      }
    },
    computed: {
      getCellListContainerClassName() {
        let bgColor = this.sectionInfo.bgColor ? ' color' : ''
        return getCellListContainerClassName(this.thumbnailInfo.type) + bgColor
      },
      getColor() {
        return 'background-color: transparent'
      },
    },
    created() {
      const contentEvent = get(this.sectionInfo, ['contentEvent', 'url'], '')
      const eventInstance = new EventModelClass({ url: contentEvent })
      const { query } = parseUrl(location.href)
      this.filterQueryMap = merge(this.filterQueryMap, query, {
        limit: this.limit,
      })
      eventInstance.filter = this.filterQueryMap
      this.currentEvent = eventInstance
      this.setData(eventInstance)
    },
    methods: {
      ...mapActions({ fetchBandData: FETCH_BAND_INFO }),
      setFilterQuery({ queryString, selectedTitle, filterIndex }) {
        this.cellList = []
        this.offset = 0
        this.endOfList = false
        this.filterTitleMap[filterIndex] = selectedTitle
        this.filterQueryMap = merge(this.filterQueryMap, parse(queryString))
        const eventInstance = new EventModelClass(this.currentEvent)
        eventInstance.filter = this.filterQueryMap
        this.setData(eventInstance)
      },
      loadMore() {
        if (this.endOfList) return
        const eventInstance = new EventModelClass(this.currentEvent)
        eventInstance.filter = this.filterQueryMap
        eventInstance.offset = this.offset
        eventInstance.limit = this.limit
        eventInstance.setPaging(true)
        this.setData(eventInstance)
      },
      setData(eventInstance) {
        if (this.isLoading) return
        this.isLoading = true
        const { query } = parseUrl(eventInstance.url)
        EventService.requestEventData(eventInstance)
          .then(({ data }) => {
            if (this.offset === 0) {
              this.filterObject = get(data, 'filter', {})
              this.thumbnailInfo = getBandTypeInfoByCellType(
                get(data, ['cell_toplist', 'cell_type'], ''),
              )
              if (get(this.filterObject, 'filterlist', []).length > 0) {
                this.hasFilter = true
              }
            }
            if (Object.keys(this.filterTitleMap).length === 0) {
              const filterList = get(this.filterObject, 'filterlist', [])
              filterList.forEach((filterItem, index) => {
                const filterItemList = get(filterItem, ['filter_item_list'], [])
                filterItemList.forEach((item, itemIndex) => {
                  const params = parse(item.api_parameters)
                  const key = Object.keys(params)[0]
                  if (query[key] === params[key]) {
                    this.filterTitleMap[index] = get(
                      filterItemList,
                      [String(itemIndex), 'title'],
                      '',
                    )
                  }
                })
              })
            }
            this.filterQueryMap =
              this.filterQueryMap === undefined
                ? parse(get(this.filterObject, 'default_api_parameters', {}))
                : this.filterQueryMap
            let resCellList = get(data, ['cell_toplist', 'celllist'], [])
            this.showEmptyList =
              this.cellList.length === 0 && resCellList.length === 0
            if (resCellList.length === 0) this.endOfList = true
            this.offset += this.limit
            this.cellList = this.cellList.concat(resCellList)
            this.hasCellList = this.cellList.length > 0
            this.isLoading = false
          })
          .catch(() => {
            this.$router.replace('/')
          })
      },
    },
  }
</script>
<style lang="css" src="@/assets/new-css/live-home.css"></style>
